import React, { useRef, useEffect, useState } from 'react';
import { cold } from 'react-hot-loader';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button, Container } from 'reactstrap';
import {
    PRIMARY_BG_COLOR,
    PRIMARY_BUTTON_COLOR,
    PRIMARY_SUBTITLE_COLOR,
    PRIMARY_TEXT_COLOR,
    PRIMARY_TITLE_COLOR,
    TEXT_FONT,
    TITLE_FONT,
    SECONDARY_BG_COLOR,
} from '../constants';
import Link from './shared/link';
import Cookies from 'js-cookie';

export const Icon = styled(({ type, ...props }) => {
    return (
        <a {...props} className={'icon-' + type} title={'Link to ' + type} rel={"nofollow"}>
            {' '}
        </a>
    );
})`
    font-family: 'fontello';
    font-style: normal;
    font-weight: normal;
    speak: none;

    display: inline-block;
    text-decoration: inherit;
    width: 1em;
    margin-right: 0.2em;
    text-align: center;

    font-variant: normal;
    text-transform: none;

    line-height: 1em;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
`;

Icon.defaultProps = {
    size: 3,
    target: '_blank',
};

Icon.propTypes = {
    size: PropTypes.number,
    href: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['facebook', 'instagram', 'linkedin', 'twitter', 'github']).isRequired,
    target: PropTypes.string,
};

export const Logo = props => {
    return (
        <LogoContainer className={props.className}>
            <svg fill={props.fill} width="200" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 28">
                <g>
                    <path d="M196.302 7.502c-.726-.606-1.45-1.06-2.176-1.326a5.566 5.566 0 0 0-2.14-.455c-.87 0-1.559.228-2.102.644-.544.417-.834.948-.834 1.63 0 .454.145.871.435 1.174.254.303.616.568 1.051.796.435.227.943.417 1.523.568.544.152 1.088.341 1.632.53 2.175.758 3.807 1.743 4.786 2.994 1.015 1.288 1.523 2.917 1.523 4.925 0 1.364-.218 2.577-.653 3.714a7.76 7.76 0 0 1-1.958 2.803c-.834.796-1.885 1.402-3.118 1.857-1.233.417-2.647.644-4.206.644-3.263 0-6.273-.985-9.065-2.993l2.865-5.57c1.015.91 1.994 1.591 2.973 2.046.979.455 1.958.682 2.9.682 1.088 0 1.922-.265 2.43-.796.544-.492.798-1.098.798-1.742 0-.417-.037-.758-.182-1.061a2.302 2.302 0 0 0-.689-.796 4.306 4.306 0 0 0-1.232-.682c-.508-.227-1.124-.455-1.85-.72a26.005 26.005 0 0 1-2.574-.91 7.851 7.851 0 0 1-2.212-1.363c-.653-.569-1.16-1.289-1.56-2.122-.398-.872-.615-1.932-.615-3.259 0-1.326.217-2.5.652-3.561a7.45 7.45 0 0 1 1.777-2.766 7.661 7.661 0 0 1 2.792-1.78C188.36.188 189.63 0 190.97 0c1.27 0 2.611.152 3.989.53 1.378.38 2.72.91 3.988 1.592l-2.646 5.38zM179 6.712h-8.131v4.34h7.685v5.711h-7.685v4.488H179V27h-15V1h15zM146.257 14.5L136 1h8.786l4.978 7.084L154.704 1H163l-9.804 13.5V27h-6.939zM135 6.712h-8.151v4.34h7.704v5.711h-7.704v4.488H135V27h-15V1h15zM108.852 1v20.251H117V27h-15V1zM90.969 22.475h-9.938L79.406 27H72L82.202 1h7.596L100 27h-7.406l-1.625-4.525zm-1.852-5.155L86.02 8.678l-3.136 8.642h6.234zM55.885 1v14.287c0 .75 0 1.538.075 2.325.074.826.223 1.538.52 2.213a3.719 3.719 0 0 0 1.378 1.575c.632.413 1.525.6 2.68.6 1.116 0 2.009-.188 2.642-.6.595-.412 1.079-.938 1.377-1.575a6.03 6.03 0 0 0 .52-2.212c.075-.788.112-1.575.112-2.325V1H72v15.225c0 4.087-.93 7.05-2.828 8.962C67.31 27.063 64.408 28 60.537 28c-3.908 0-6.81-.938-8.709-2.813C49.968 23.276 49 20.313 49 16.226V1h6.885zM0 1v26h15v-5.749H6.849v-4.488h7.704v-5.712H6.85v-4.34H15V1zM17 13.565c0 .844.076 1.656.267 2.435h7.657c-.114-.26-.534-1.364-.534-2.435 0-1.266.572-2.5.572-2.5 0-.033.038-.065.038-.065h-7.695c-.19.812-.305 1.656-.305 2.565z" />
                    <path d="M46.082 19.096c.59-1.553.885-3.258.885-5.077 0-1.97-.332-3.827-1.07-5.532a13.9 13.9 0 0 0-2.988-4.433 14.398 14.398 0 0 0-4.611-2.993C36.527.34 34.572 0 32.469 0c-2.14 0-4.058.341-5.829 1.06a13.47 13.47 0 0 0-4.574 2.994A15.55 15.55 0 0 0 20 6.668h12.58c.959.038 1.844.228 2.73.569.885.379 1.66.871 2.36 1.515.665.682 1.218 1.44 1.587 2.35.406.87.59 1.856.59 2.917 0 1.553-.406 2.917-1.254 4.054l-1.033-1.137h-7.673l4.39 4.168c-.185.152-.787.228-1.808.228H20c.59.947 1.254 1.856 2.066 2.652 1.254 1.25 2.767 2.235 4.574 2.955C28.411 27.66 30.33 28 32.47 28c1.254 0 2.472-.114 3.615-.379a15.023 15.023 0 0 0 3.247-1.137L40.733 28H48l-4.464-4.698a12.745 12.745 0 0 0 2.546-4.206zM32.25 21H32h.25zM32.15 21H32h.15z" />
                </g>
            </svg>
        </LogoContainer>
    );
};

export const LogoContainer = styled.div`
    flex-grow: 1;
    width: 210px;
    height: 30px;
    text-align: left;
    svg {
        display: inline-block;
        fill: ${props => props.fill};
        transition: fill 200ms linear;
    }

    @media (max-width: 992px) {
        height: 28px;

        svg {
            height: 25px;
            width: auto;
        }
    }

    @media (max-width: 768px) {
        height: 23px;

        svg {
            height: 20px;
            width: auto;
        }
    }
`;

export const CallToActionButton = styled(Button)`
    font-family: ${TITLE_FONT} !important;
    font-weight: bold !important;
    font-size: 14px !important;
    background-color: ${PRIMARY_BUTTON_COLOR} !important;
    color: black !important;
    border-radius: 5px !important;
    border: none !important;
    padding: 10px 25px !important;
    letter-spacing: 1px !important;
    margin-bottom: ${params => (params.mb ? params.mb : '100px')} !important;
    text-transform: uppercase !important;

    ${props =>
        props.shadow === null
            ? `
        outline: 0 !important;
        outline-offset: 0  !important;
        background-image: none  !important;
        -webkit-box-shadow: none !important;
        box-shadow: none  !important;
    `
            : `
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
    `}
`;

export const MainText = styled.h1`
    font-family: ${TITLE_FONT};
    color: ${props => props.color};
    letter-spacing: -0.2px;
    font-size: ${props => props.size};
    margin-bottom: ${props => props.marginbottom};
    margin-top: ${props => props.margintop};
    font-weight: bold;

    @media (max-width: 768px) {
        margin-bottom: 30px;
        font-size: 32px;
    }

    @media (max-height: 700px) {
        font-size: 32px;
    }
`;

MainText.defaultProps = {
    color: PRIMARY_TEXT_COLOR,
    size: '44px',
    marginBottom: '20px',
    marginTop: '10px',
};

MainText.propsTypes = {
    color: PropTypes.string,
    size: PropTypes.string,
    marginBottom: PropTypes.string,
    marginTop: PropTypes.string,
};

export const SubText = styled.h3`
    font-family: ${TITLE_FONT};
    color: ${props => props.color};
    letter-spacing: -0.2px;
    font-size: ${props => props.size};
    margin-bottom: 90px;

    @media (max-width: 768px) {
        margin-bottom: 30px;
        font-size: 18px;
    }
`;

SubText.defaultProps = {
    color: PRIMARY_TEXT_COLOR,
    size: '22px',
};

SubText.propsTypes = {
    color: PropTypes.string,
    size: PropTypes.string,
};

export const FontIcon = styled.i`
    font-family: fontello;
    font-style: normal;
`;

export const SeeMore = styled(({ color, marginBottom, to, ...props }) => {
    return (
        <div {...props}>
            <Link to={to}>
                See more <FontIcon></FontIcon>
            </Link>
        </div>
    );
})`
    margin-bottom: ${props => props.marginbottom};
    margin-top: ${props => props.margintop};

    a {
        color: ${props => props.color};
        font-size: 20px;
        font-weight: 400;
        font-family: ${TITLE_FONT};

        @media (max-width: 768px) {
            font-size: 18px;
        }

        @media (max-height: 700px) {
            font-size: 18px;
        }

        &:hover {
            color: ${PRIMARY_SUBTITLE_COLOR};
        }
    }
`;

SeeMore.propTypes = {
    href: PropTypes.string,
    to: PropTypes.string,
};

SeeMore.defaultProps = {
    color: PRIMARY_TITLE_COLOR,
};

const HeroLink = styled(Link)`
    display: flex;
    flex-direction: column;

    video {
        flex-grow: 1;
        flex-shrink: 0;
        position: absolute;
        top: 0;
        left: 0;
    }

    div {
        flex-grow: 0;
    }
`;

export const OverlinedSubTitle = styled.h3`
    font-family: ${TITLE_FONT};
    font-size: 18px;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: -0.2px;
    color: ${props => (props.txtcolor ? props.txtcolor : PRIMARY_BG_COLOR)};
    border-top: 2px solid ${props => (props.txtcolor ? props.txtcolor : PRIMARY_BG_COLOR)};
    padding-top: 20px;
    margin-bottom: 40px;
    margin-top: 0;
`;

export const HeroImage = styled(
    cold(({ title, subTitle, image, video, playing, ...props }) => {
        const videoRef = useRef();

        useEffect(() => {
            if (playing) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
                videoRef.current.currentTime = 0;
            }
        }, [playing, videoRef]);

        return (
            <HeroLink {...props}>
                <div className="video">
                    <video ref={videoRef} poster={image} loop muted>
                        <source src={video} type="video/mp4" />
                    </video>
                </div>
                <Container className="d-flex flex-column justify-content-center h-100">
                    <div className="meta">
                        <h3>{title}</h3>
                        <h5>{subTitle}</h5>
                    </div>
                </Container>
            </HeroLink>
        );
    }),
)`
    :hover {
        text-decoration: none;
    }

    video {
        width: 100%;
        height: auto;
        max-height: 100%;
    }

    .video {
        flex-grow: 1;
        flex-shrink: 0;
    }

    .meta {
        height: 150px;
    }

    h3 {
        font-family: ${TITLE_FONT};
        font-size: 34px;
        color: ${PRIMARY_TEXT_COLOR};
        margin-top: 30px;
    }

    h5 {
        font-family: ${TITLE_FONT};
        font-size: 22px;
        color: ${PRIMARY_TEXT_COLOR};
        font-weight: 300;
    }
`;

export const TitleText = styled.h1`
    font-family: ${TITLE_FONT};
    font-size: 120px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.23;
    letter-spacing: -3.5px;
    color: #ffffff;

    @media (max-width: 992px) {
        font-size: 100px;
    }

    @media (max-width: 768px) {
        font-size: 50px;
        word-wrap: break-word;
    }
`;

export const TitleContainer = styled(Container)`
    z-index: 1;
`;

export const Title = styled.div`
    font-family: ${TEXT_FONT};
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.2px;
    color: ${PRIMARY_BG_COLOR};
    margin-bottom: 60px;
    background-color: ${PRIMARY_BUTTON_COLOR};
    display: inline-block;
    padding: 4px 10px 0 10px;

    @media (max-width: 992px) {
        font-size: 20px;
        letter-spacing: normal;
    }
`;

export const BadgeLanguage = styled.div`
    span {
        border-radius: 4px;
        padding: 2px 30px;
        font-size: 18px;
        letter-spacing: 0.1px;
        cursor: pointer;
        font-family: ${TITLE_FONT};
        margin-right: 10px;
        border: 2px solid ${SECONDARY_BG_COLOR};
    }

    .black {
        background-color: ${SECONDARY_BG_COLOR};
        color: white;
    }
`;

export const CookiesToast = () => {
    const [accepted, setAccepted] = useState(true);
    let iOs = false;
    if (typeof window !== 'undefined') {
        if (/iP(hone|od|ad)/.test(window.navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            iOs = true;
        }
    }

    useEffect(() => {
        setAccepted(Cookies.get('accept_cookies') || false);
    }, []);

    const GeneralCookieButton = () => {
        return (
            <button
                onClick={() => {
                    setAccepted(true) || Cookies.set('accept_cookies', true, { expires: 2147483647 });
                }}
            >
                I AGREE
            </button>
        );
    };

    const IosCookieButton = () => {
        return (
            <button
                onTouchStart={() => {
                    setAccepted(true) || Cookies.set('accept_cookies', true, { expires: 2147483647 });
                }}
            >
                I AGREE
            </button>
        );
    };

    const ToastContainer = styled.div`
        position: fixed;
        bottom: 5vh;
        left: 2.5vw;
        right: 2.5vw;
        z-index: 2;
        width: 95vw;
        background-color: #343434;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        font-family: ${TITLE_FONT};
        padding: 10px 5px;

        @media (max-width: 768px) {
            flex-direction: column;
        }

        button {
            background-color: black;
            color: white;
            border: none;
            padding: 5px 30px;
            margin: 10px;
            border-radius: 4px;
            font-weight: bold;
            font-size: 15px;

            :hover {
                color: black;
                background-color: ${PRIMARY_BUTTON_COLOR};
            }

            @media (max-width: 768px) {
                max-width: 50vw;
                margin: 10px auto;
            }
        }

        div {
            color: #959595;
            margin-left: 20px;
            display: flex;
            justify-content: center;
            flex-direction: column;

            a {
                color: inherit;
                text-decoration: underline;
            }
        }
    `;

    return (
        <ToastContainer className={accepted ? 'd-none' : 'd-flex'}>
            <div className="flex-grow-1">
                <span>
                    This website uses cookies. By continuing to browse the site, you are agreeing to our use of{' '}
                    <Link to={'/cookies'}>cookies</Link>.
                </span>
            </div>
            {iOs ? <IosCookieButton /> : <GeneralCookieButton />}
        </ToastContainer>
    );
};
